/**
* Tabbed Slider JS
* -----------------------------------------------------------------------------
*
* All the JS for the Tabbed Slider component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {
    className: 'tabbed-slider',
    selector: function() {
      return '.' + this.className;
    },
    init: function() {
      $( '.tabbed-slider' ).each( function() {
        const container = $( this );
        const sliderEl = container.find( '.tabbed-slider__splide' )[0];
        const prev = container.find( '.tabbed-slider__prev' )[0];
        const next = container.find( '.tabbed-slider__next' )[0];
        const progressBars = container.find( '.progressBar' );

        if ( !sliderEl ) return;

        const splide = new Splide( sliderEl, {
          type: 'loop',
          perPage: 1,
          arrows: false,
          pagination: false,
          rewind: true,
        } );

        let tick = null;
        let percentTime = 0;
        let progressBarIndex = 0;
        const time = 8;

        function resetProgressbar() {
          progressBars.find( '.inProgress' ).css( {width: '0%'} );
          if ( tick ) {
            clearInterval( tick );
            tick = null;
          }
        }

        function interval() {
          const currentSlide = splide.index;

          if ( currentSlide !== progressBarIndex ) {
            progressBarIndex = currentSlide;
            percentTime = 0;
            resetProgressbar();
            startProgressbar();
            return;
          }

          percentTime += 1 / ( time * 50 );

          progressBars.eq( progressBarIndex ).find( '.inProgress' )
              .css( {width: `${percentTime * 100}%`} );

          if ( percentTime >= 1 ) {
            resetProgressbar();
            splide.go( '>' );
          }
        }

        function startProgressbar() {
          if ( tick ) return;
          percentTime = 0;
          tick = setInterval( interval, 20 );
        }

        $( prev ).on( 'click', () => {
          resetProgressbar();
          splide.go( '<' );
        } );

        $( next ).on( 'click', () => {
          resetProgressbar();
          splide.go( '>' );
        } );

        progressBars.on( 'click', function() {
          const index = $( this ).data( 'slide' );
          if ( index === splide.index ) {
            percentTime = 0;
            startProgressbar();
          } else {
            percentTime = 0;
            resetProgressbar();
            splide.go( index );
          }
        } );

        splide.on( 'moved', ( newIndex ) => {
          progressBarIndex = newIndex;
          percentTime = 0;
          startProgressbar();
        } );

        splide.on( 'mounted', () => {
          progressBarIndex = splide.index || 0;
          percentTime = 0;
          startProgressbar();
        } );

        splide.mount();
      } );
    },
    finalize: function() {},
  };
  app.registerComponent( 'tabbed-slider', COMPONENT );
} )( app );
